import { useIsVendorMasqueradeAvailable } from '@aegix/auth-organization';
import { useSsoCapabilities } from './useSsoCapabilities';

/**
 * Gate for the multi-tenant organization-management surface.
 *
 * Originally gated the Organizations sub-tab under Admin > Directory; ADR-114
 * Phase 1 removed that sub-tab, and Phase 3 will re-mount the same
 * `OrganizationsContent` UI on the `VendorOrgSelector` dropdown. This hook is
 * the gate for that affordance, regardless of where it renders.
 *
 * Mirrors the existing SSO sub-tab gating pattern in `AuthorizationContent`:
 * we reuse the SSO capabilities endpoint to know whether the current user is
 * Django staff (Aegix-internal). Vendor users come from AuthContext.
 *
 * Backend enforcement lives in `DistrictViewSet.get_queryset` — this hook is
 * a UX affordance, not a security boundary.
 */
export function useCanManageOrganizations(): boolean {
  const isVendorUser = useIsVendorMasqueradeAvailable();
  const ssoCaps = useSsoCapabilities();
  return Boolean(isVendorUser) || Boolean(ssoCaps.data?.is_staff);
}
